<template>
  <div class="w-full bg-white flex flex-col pb-[12.5px]">
    <div
      class="w-[60px] min-h-1 max-h-1 bg-gray-800/20 rounded-xs self-center mt-2.5 mb-1.5"
    />

    <div
      class="w-full min-h-[52px] max-h-[52px] px-[14px] flex items-center font-secondary text-gray-800"
    >
      <ThumbnailIcon
        :image-url="imageUrl"
        :icon-size="36"
        :type="props.item.type"
        class="min-w-9 max-w-9 h-9 mr-2.5"
      />

      <div v-truncate class="w-full">
        <div
          class="font-medium text-[17px] leading-[18px]"
          data-truncate-target
        >
          {{ props.item.fileName }}
        </div>
        <div class="flex items-center text-[13px] opacity-50">
          Archived on {{ formatTimestamp(props.item.archivedAt) }}
        </div>
      </div>
    </div>

    <div class="w-full my-[12.5px] min-h-[1px] max-h-[1px] bg-gray-800/10" />

    <TallListItem icon="Info" @click="handleFileInfoClick">
      Copyright info
    </TallListItem>

    <TallListItem icon="Clock" @click="handleTransactionClick">
      Transaction history
    </TallListItem>
  </div>
</template>

<script setup lang="ts">
import { ThumbnailIcon } from '@dacr/ui'
import { TallListItem } from '@/shared/components/Menu'
import type { ArchivedFile } from '@/shared/graphql/legacy/generated'
import { applyAuthorizationToken } from '@/shared/utils/url'
import { formatTimestamp } from '@/shared/utils/datetime'
import { useDialog } from '@/shared/dialogs/useDialog'
import { Dialogs } from '@/shared/dialogs/types'
import { computed } from 'vue'

const props = defineProps<{
  item: ArchivedFile
}>()

const { open } = useDialog()

const imageUrl = computed(() =>
  props.item.imageUrl
    ? applyAuthorizationToken(props.item.imageUrl, [
        { key: 'width', value: 72 },
      ])
    : undefined
)

const handleFileInfoClick = () => {
  open(Dialogs.CopyrightInfo, {
    props: { file: props.item },
  })
}

const handleTransactionClick = () => {
  open(Dialogs.TransactionHistory, {
    props: { transactions: props.item.transactions },
  })
}
</script>
